import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import {
	mainnet,
	bsc,
	zksync,
	linea,
	arbitrum,
	scroll,
	polygon,
	taiko,
} from 'wagmi/chains'
import { http } from 'wagmi'

export const wagmiConfig = getDefaultConfig({
	appName: 'Symbiosis Rewards',
	projectId: 'a2a1ecab7189c9e050751b785a3d4ca9',
	chains: [mainnet, bsc, zksync, linea, arbitrum, scroll, taiko, polygon],
	transports: {
		[mainnet.id]: http('https://ethereum-rpc.publicnode.com'),
		[bsc.id]: http('https://bsc-rpc.publicnode.com'),
		[zksync.id]: http('https://mainnet.era.zksync.io'),
		[linea.id]: http('https://rpc.linea.build'),
		[arbitrum.id]: http('https://arbitrum-one-rpc.publicnode.com'),
		[scroll.id]: http('https://scroll-rpc.publicnode.com'),
		[taiko.id]: http('https://taiko-rpc.publicnode.com'),
		[polygon.id]: http('https://polygon-bor-rpc.publicnode.com'),
	},
})
